import { RNSStatus } from '../pars-status-widget/RNS-status';

export class RNSStatusReportRequest {

    public From: Date;
    public To: Date;
    public Status: RNSStatus;
    public Skip: number = 0;
    public Top?: number = 20;

    constructor(obj?: Partial<RNSStatusReportRequest>) {
        Object.assign(this, obj);
    }
}



// WEBPACK FOOTER //
// ./app/objects/requests/RNSStatusReportRequest.ts